import { ArrowRightIcon, Card, CardContent, CardHeader, IconButton, useRouter } from '@forgeglobal/design-framework'
import { useIssuerTradeSummaryQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

import { TradeDetail } from './TradeDetail'

const LatestTrade: React.FC<{ openSidebar: () => void }> = ({ openSidebar }) => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useIssuerTradeSummaryQuery({ variables: { id: match.params.id } })
  const lastDeal = data?.account?.issuer_account?.deals?.[0]

  return lastDeal ? (
    <Card>
      <CardHeader
        title="Latest Trade"
        action={
          <IconButton onClick={openSidebar}>
            <ArrowRightIcon />
          </IconButton>
        }
      />
      <CardContent>
        <TradeDetail deal={lastDeal} />
      </CardContent>
    </Card>
  ) : null
}

export { LatestTrade }
